
export const telefono = '(11) 51994700';
export const telefonoSecundario = '(11) 5199-4787';
export const telefonoMiClubCallcenter = '(11) 5199-4740';
export const mailAccesoDigital = 'accesodigital@lanacion.com.ar';
export const mailAtencionSocios = 'atencionsocios@lanacion.com.ar';
export const horario = 'Lunes a Viernes de 8:00 a 20:00hs.';